import React from "react";
import { withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import memoizeOneWithParamsCheck from "../../../utils/memoizeOne";
import { getDocumentStatusEnumsTranslationNamespaces } from "../../documents/DocumentDef";
import Page, { IPageParams, IProps as IPageProps } from "../../Page";
import { commonReportTranslations, getReportDefinition } from "../Report.utils";
import { ReportSplitPage } from "../ReportSplitPage";
import { IReportViewBaseProps } from "../ReportView";
import { getDefinition } from "./VatOssStatementReportDef";

class VatOssStatementReport extends Page<IPageProps> {
    static contextType = AppContext;

    static defaultProps = {
        getDef: getReportDefinition.bind(null, getDefinition)
    };

    getReportViewProps = memoizeOneWithParamsCheck((): Partial<IReportViewBaseProps> => {
        return {
            expandable: true
        };
    });

    render = () => {
        if (!this.isReady()) {
            return null;
        }

        return (
            <ReportSplitPage
                {...this.getMandatoryProps()}
                reportViewProps={this.getReportViewProps()}
            />
        );
    };
}

export default withRouter<RouteComponentProps<IPageParams>, any>(withTranslation([
    ...commonReportTranslations, "Document", "ElectronicSubmission",
    ...getDocumentStatusEnumsTranslationNamespaces()
])(VatOssStatementReport));